import React, { useState, useEffect } from 'react';
import AdminLayout from './AdminLayout';
import { getSections, updateSection } from '../../services/api';
import { triggerDataRefresh } from '../../context/SiteDataContext';
import './admin.css';

const ContactEditor = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const response = await getSections(true);
      setConfig(response.contactConfig || {
        formspreeId: 'mayrvarb',
        defaultSubject: 'Nouveau message depuis le site',
        recipientEmail: '',
        subtitle: 'CONTACT',
        title: 'Ecrivez-moi !',
        btnText: 'Envoyer',
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setConfig(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setSaving(true);

    try {
      if (config.id) {
        await updateSection(config.id, 'contactConfig', config);
      }
      setSuccess('Configuration enregistrée !');
      triggerDataRefresh();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="admin-loading"><div className="spinner"></div></div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="admin-page">
        <header className="admin-page-header">
          <div>
            <h1>Configuration Contact</h1>
            <p>Paramètres du formulaire de contact</p>
          </div>
        </header>

        {error && <div className="admin-alert admin-alert-error">{error}</div>}
        {success && <div className="admin-alert admin-alert-success">{success}</div>}

        <form onSubmit={handleSubmit} className="admin-form">
          <div className="admin-form-grid">
            <div className="admin-form-group">
              <label>ID Formspree</label>
              <input
                type="text"
                value={config?.formspreeId || ''}
                onChange={(e) => handleChange('formspreeId', e.target.value)}
                placeholder="mayrvarb"
              />
              <small>L'identifiant de votre formulaire Formspree</small>
            </div>

            <div className="admin-form-group">
              <label>Email destinataire</label>
              <input
                type="email"
                value={config?.recipientEmail || ''}
                onChange={(e) => handleChange('recipientEmail', e.target.value)}
                placeholder="contact@example.com"
              />
            </div>

            <div className="admin-form-group full-width">
              <label>Sujet par défaut</label>
              <input
                type="text"
                value={config?.defaultSubject || ''}
                onChange={(e) => handleChange('defaultSubject', e.target.value)}
                placeholder="Nouveau message depuis le site"
              />
            </div>

            <div className="admin-form-group">
              <label>Sous-titre (affiché en haut)</label>
              <input
                type="text"
                value={config?.subtitle || ''}
                onChange={(e) => handleChange('subtitle', e.target.value)}
                placeholder="CONTACT"
              />
            </div>

            <div className="admin-form-group">
              <label>Titre</label>
              <input
                type="text"
                value={config?.title || ''}
                onChange={(e) => handleChange('title', e.target.value)}
                placeholder="Ecrivez-moi !"
              />
            </div>

            <div className="admin-form-group">
              <label>Texte du bouton</label>
              <input
                type="text"
                value={config?.btnText || ''}
                onChange={(e) => handleChange('btnText', e.target.value)}
                placeholder="Envoyer"
              />
            </div>
          </div>

          <div className="admin-form-actions">
            <button
              type="submit"
              className="admin-btn admin-btn-primary"
              disabled={saving}
            >
              {saving ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
};

export default ContactEditor;

